import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../components/ui/accordion';
import { faqItems } from '../../data/mock';

const FAQSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="caption mb-4 block">Häufige Fragen</span>
          <h2 className="heading-2 mb-6">
            FAQ zur <span className="text-[#FF0000]">Unternehmensbewertung</span>
          </h2>
          <p className="body-medium max-w-2xl mx-auto">
            Antworten auf die wichtigsten Fragen rund um die Bewertung Ihres Unternehmens.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqItems.map((item) => (
            <AccordionItem
              key={item.question}
              value={`item-${item.question}`}
              className="bg-[#f8f9fa] border border-gray-100 rounded-xl px-6 overflow-hidden data-[state=open]:border-[#FF0000]/30 data-[state=open]:shadow-md"
            >
              <AccordionTrigger className="py-6 text-left hover:no-underline group">
                <span className="text-[#1a1c1b] font-semibold text-lg group-hover:text-[#FF0000] transition-colors pr-4">
                  {item.question}
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-6">
                <p className="text-[#5a5d5b] leading-relaxed">
                  {item.answer}
                </p>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        {/* NOTE: FAQPage schema is provided by SSG (generate-static-pages.js) in the <head>.
            React does NOT inject a separate FAQPage schema to avoid duplicates after hydration.
            The SSG FAQPage has the 5 homepage-specific questions, not the 12 general faqItems. */}
      </div>
    </section>
  );
};

export default FAQSection;
